import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];

  connect() {
    this.modalTarget = document.getElementById('shoppingCartModal');
  }

  toggleModal() {
    this.modalTarget.classList.toggle('hidden');
    document.body.classList.toggle('modal-open');
  }
}

